export default __webpack_public_path__ + "static/media/hackathon.8ed65c97.svg";